import React, { createContext, useContext, useReducer } from 'react';
export var StateContext = createContext({});
export var StateProvider = function (_a) {
    var children = _a.children, mainReducer = _a.mainReducer, initialState = _a.initialState;
    return (React.createElement(StateContext.Provider, { value: useReducer(mainReducer, initialState) }, children));
};
export var useStateValue = function () { return useContext(StateContext); };
